module.exports = __webpack_public_path__ + "static/media/box_warning_mobile.6565ffd5.jpg";